import axios from 'axios';
import {
  POST_CONTACT_US_FORM_REQUEST,
  POST_CONTACT_US_FORM_SUCCESS,
  POST_CONTACT_US_FORM_FAILURE,
  GET_CONTACT_US_CATEGORIES_REQUEST,
  GET_CONTACT_US_CATEGORIES_SUCCESS,
  GET_CONTACT_US_CATEGORIES_FAILURE,
  GET_CONTACT_US_SUBCATEGORIES_REQUEST,
  GET_CONTACT_US_SUBCATEGORIES_SUCCESS,
  GET_CONTACT_US_SUBCATEGORIES_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { getChannel } from 'Utils/channel';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const postContactUsForm = formData => async (dispatch, getState) => {
  const isAuth = getState().auth.isAuthenticated;

  try {
    dispatch({
      type: POST_CONTACT_US_FORM_REQUEST
    });

    const url = isAuth ? `${API_GATEWAY}/bip-ticket` : `${API_GATEWAY}/bip-ticket/anonymous`;

    const res = await axios({
      url,
      method: 'POST',
      data: formData,
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: POST_CONTACT_US_FORM_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: POST_CONTACT_US_FORM_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getCategories = () => async dispatch => {
  try {
    dispatch({
      type: GET_CONTACT_US_CATEGORIES_REQUEST
    });

    const res = await axios({
      method: 'GET',
      url: `${API_GATEWAY}/bip-ticket/categories`,
    });

    dispatch({
      type: GET_CONTACT_US_CATEGORIES_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_CONTACT_US_CATEGORIES_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getSubCategories = categoryId => async dispatch => {
  try {
    dispatch({
      type: GET_CONTACT_US_SUBCATEGORIES_REQUEST
    });

    const res = await axios({
      method: 'GET',
      url: `${API_GATEWAY}/bip-ticket/categories/${categoryId}`
    });

    dispatch({
      type: GET_CONTACT_US_SUBCATEGORIES_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: GET_CONTACT_US_SUBCATEGORIES_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
